import loadable from '@loadable/component';
import React from 'react';
import {View} from 'react-native';
import styles from './VehicleIcon.style';
const SVG = loadable(() => import('../../../../imports/svg'));

export default function VehicleIcon(props) {
  const {containerStyle, size, VehicleBrand = ''} = props;

  return (
    <View style={[styles.container, containerStyle]}>
      <SVG
        name={
          VehicleBrand == '4'
            ? 'bicycleVector'
            : VehicleBrand == '3'
            ? 'motorVectorMado'
            : 'motorVectorTusan'
        }
        width={size ?? 48}
        height={size ?? 48}
      />
    </View>
  );
}
